import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import _isEqual from 'lodash/isEqual';
import _uniqBy from 'lodash/uniqBy';
import KoIcon from '@kwapio/icons';
import {
  KoText,
  KoModal,
  KoButton,
  KoForm,
  KoLoader,
  KoNano,
  KoTitle,
  KoToast,
  KoFolderCrud,
  KoUpload,
  KoSelect,
  KoDropdown,
  KoBreadcrumb,
  KoSearch,
  KoAffix,
  KoEmpty
  // KoTag
} from "packages";
import styles from "./drive.module.scss";
import { FilesAPI } from './files.service';
import FileSharePanel from './fileSharePanel';
import { useParams } from 'react-router';
import { getCookie } from 'shared/utils/cookies';
import FileRenameCrud from './renameCrud';
import { downloadFile, exportSlateToDocx } from './downloaddocx';
import { findFolderById, getDrivePermission, getFlattenedFoldersWithPaths } from 'shared/utils';
import FileInfo from './fileObject';
import { workspaceAPI } from 'pages/workspace/workspace.service';

function FileDrive() {

  const { workspaceId } = useParams();
  const [isFolderOpen, setFolderModal] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [currentFile, setCurrentFile] = useState();
  const [currentFolder, setCurrentFolder] = useState();
  const [isOpenDelete, setDeleteModal] = useState(false);
  const [isdeleteFile, setDeleteFileModal] = useState(false);
  const [selectedDocx, setSelectedDocx] = useState([]);
  const [, setTotalCount] = useState();
  const [, setTotalFolderCount] = useState();
  const [targetFolder, setTargetFolder] = useState();
  const [targetWorkspace, setTargetWorkspace] = useState();
  const [folders, setFolders] = useState();
  const [recentRequestList, setRecentRequestList] = useState();
  const [isFileShareOpen, setFileShareModal] = useState(false);
  const [isFolderShareOpen, setFolderShareModal] = useState(false);
  const [uploadFileModal, setUploadFileModal] = useState(false);
  const [moveFileModal, setMoveFileModal] = useState(false);
  const [linkToWorkspaceModal, setLinkToWorkspaceModal] = useState(false);
  const [renameFileModal, setRenameFileModal] = useState(false);
  const [breadcrumbPath, setBreadcrumbPath] = useState([]);
  const [workspaces, setWorkspaces] = useState();
  const [folderSubModal, setFolderSubModal] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [highlightedFolder, setHighlightedFolder] = useState();
  const [highlightedFile, setHighlightedFile] = useState();
  const [initialShared, setInitialShared] = useState();
  let navigate = useNavigate();

  const [pagination] = useState({
  });

  const [paginationFolder] = useState({
  });

  const [form] = KoForm.useForm();
  const [rform] = KoForm.useForm();
  const [subform] = KoForm.useForm();

  useEffect(() => {
    getinistallData(paginationFolder);
  }, []);

  const getinistallData = () => {
    let pf = {
    };
    let pd = {
    };
    getWorkspace();
    setCurrentFolder();
    setBreadcrumbPath();
    getFolders(pf);
    getDocuments(pd);
  };

  const getWorkspace = () => {
    setLoading(true);
    workspaceAPI.getWorkspace().then(
      (data) => {
        setWorkspaces();
        setWorkspaces(data['workspaces']);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const getFolders = (q, values) => {
    setLoading(true);
    FilesAPI.getFolders(q).then(
      (data) => {
        setFolders(data['folders'] || []);
        setTotalFolderCount(data['totalCount']);
        setFolderModal(false);
        if (values) {
          setHighlightedFolder(values);
        }
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const getDocuments = (q, values, folderId = 'root') => {
    setLoading(true);
    setRecentRequestList();
    FilesAPI.getDocuments(q, folderId).then(
      (data) => {
        setRecentRequestList(data['files']);
        setHighlightedFile(values);
        setTimeout(() => {
          setHighlightedFile();
        }, 1000);
        setTotalCount(data['totalCount']);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const handleFolderFinish = (values => {
    if (!currentFolder?.folderId) {
      values['folderId'] = KoNano('FOL');
    }
    if (currentFolder?.folderId) {
      values['parentFolderId'] = currentFolder?.folderId;
    }
    setLoading(true);
    FilesAPI.createOrUpdateFolder(values, currentFolder?.folderId, workspaceId).then(
      (data) => {
        getFolders(paginationFolder, values);
        setFolderModal(false);
        setLoading(false);
        KoToast.success(`Folder ${currentFolder?.folderId ? 'updated' : 'created'} successfully`);
      },
      (err) => {
        setLoading(false);
      }
    );
  });

  const handleFolderSubFinish = (values => {
    values['folderId'] = KoNano('FOL');
    if (currentFolder?.folderId) {
      values['parentFolderId'] = currentFolder?.folderId;
    }
    setLoading(true);
    FilesAPI.createOrUpdateFolder(values, null, workspaceId).then(
      (data) => {
        getByFolderId(currentFolder, values);
        setFolderSubModal(false);
        setLoading(false);
        KoToast.success(`Folder created successfully`);
      },
      (err) => {
        setLoading(false);
      }
    );
  });

  const handleFileShareFinish = (values => {
    const hasSharedWithChanged = !_isEqual(currentFile?.sharedWith, values.sharedWith);
    if (hasSharedWithChanged && (values.sharedWith.users || values.sharedWith.groups)) {
      setLoading(true);
      let obj = {
        documentId: selectedDocx?.length > 0 ? selectedDocx : [currentFile?.documentId],
        ...values,
        name: 'file'
      };

      FilesAPI.fileShare(obj).then(
        (data) => {
          setSelectedDocx([]);
          setHighlightedFolder();
          getDocuments(pagination);
          setLoading(false);
          KoToast.success(`File shared successfully`);
        },
        (err) => {
          KoToast.error(`Please try again`);
          setLoading(false);
        }
      );
    }
  });

  const handleFolderShareFinish = (values => {
    const hasSharedWithChanged = !_isEqual(currentFolder?.sharedWith, values.sharedWith);
    if (hasSharedWithChanged && (values.sharedWith.users || values.sharedWith.groups)) {
      setLoading(true);
      let obj = {
        documentId: selectedDocx?.length > 0 ? selectedDocx : [currentFolder?.folderId],
        ...values,
        name: 'folder'
      };

      FilesAPI.fileShare(obj).then(
        (data) => {
          getFolders(paginationFolder);
          setFolderModal(false);
          setSelectedDocx([]);
          setLoading(false);
          KoToast.success(`Folder shared successfully`);
        },
        (err) => {
          KoToast.error(`Please try again`);
          setLoading(false);
        }
      );
    }
  });

  const handleFinishDelete = () => {
    setLoading(true);
    FilesAPI.deleteFolderById(currentFolder?.folderId).then(
      (data) => {
        if(breadcrumbPath?.length>0){
          getByFolderId(currentFolder?.folderId);
        }else{
          getFolders(paginationFolder);
        }
        setLoading(false);
        setDeleteModal(false);
        setCurrentFolder();
        KoToast.success(`Folder deleted successfully!`);
      },
      (err) => {
        KoToast.error(`error`);
        setLoading(false);
      }
    );
  };

  const handleFinishDeleteFile = () => {
    setLoading(true);
    let fids = {
      documentId: selectedDocx?.length > 0 ? selectedDocx : [currentFile?.documentId]
    };
    FilesAPI.deleteDocumentById(fids).then(
      (data) => {
        getDocuments(pagination, null, currentFolder?.folderId);
        setLoading(false);
        setSelectedDocx([]);
        setDeleteFileModal(false);
        KoToast.success(`Document deleted successfully!`);
      },
      (err) => {
        KoToast.error(`error`);
        setLoading(false);
      }
    );
  };

  const onDelete = (record) => {
    setCurrentFile(record);
    setDeleteFileModal(true);
  };



  const props = {
    name: 'files',
    multiple: true,
    action: currentFolder?.folderId ? `${process.env.REACT_APP_PROXY_HOST}/api/v1/file/upload/files?folderId=${currentFolder?.folderId}` : `${process.env.REACT_APP_PROXY_HOST}/api/v1/file/upload/files`,
    headers: {
      Authorization: `Bearer ${getCookie("accessToken")}`
    },
    onChange(info) {
      const { status } = info.file;
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        if(breadcrumbPath?.length>0){
          getByFolderId(paginationFolder, currentFolder?.folderId);
        }else{
          getFolders(paginationFolder, currentFolder);
        }
        setUploadFileModal(false);
        getDocuments(pagination, null, currentFolder?.folderId);
       
        KoToast.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === 'error') {
        KoToast.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    }
  };

  const onCellClick = (data) => {
    setCurrentFile(data);
  };


  const onDocxSelection = (docId) => {
    const matches = recentRequestList
      ?.filter((item) => item?.documentId === docId)
      .map((item) => item.sharedWith);

    const mergedSharedWith = matches.reduce(
      (acc, current) => {
        acc.users = _uniqBy([...acc.users, ...(current?.users || [])], 'userId');
        acc.groups = _uniqBy([...acc.groups, ...(current?.groups || [])], 'groupId');
        return acc;
      },
      { users: [], groups: [] }
    );

    setInitialShared(mergedSharedWith);
    setSelectedDocx((prevSelected) => {
      if (prevSelected.includes(docId)) {
        return prevSelected.filter((id) => id !== docId);
      } else {
        return [...prevSelected, docId];
      }
    });
  };

  const onSelectTargetFolder = (folder) => {
    setTargetFolder(folder);
  };

  const onSelectTargetWorkspace = (folder) => {
    let obj = {
      projectLink: folder
    };
    setTargetWorkspace(obj);
  };

  const moveToFolder = (pagination, cFolder) => {
    setLoading(true);
    let fs = findFolderById(folders, targetFolder);
    FilesAPI.moveDocumentToFolder({ documentId: selectedDocx }, targetFolder).then(
      (data) => {
        let q = pagination;
        q['folderId'] = targetFolder;
        getFolders(paginationFolder, fs);
        getDocuments(pagination, null, cFolder?.folderId);
        setLoading(false);
        setSelectedDocx([]);
        setMoveFileModal(false);
        KoToast((t) => (
          <div className={'toastExtension'}>
            Document moved successfully!
            <KoButton onClick={() => getByFolderId(fs)} type="link" label="Open" />
          </div>
        ));
      },
      (err) => {
        setLoading(false);
        KoToast.error(`error`);
      }
    );
  };

  const LinkToWorkspace = () => {
    setLoading(true);
    if (currentFolder?.folderId) {
      let obj = currentFolder;
      obj['projectLink'] = targetWorkspace.projectLink;
      FilesAPI.createOrUpdateFolder(obj, currentFolder?.folderId).then(
        (data) => {
          getFolders(paginationFolder, currentFolder, 'false');
          setLoading(false);
          setLinkToWorkspaceModal(false);
          KoToast.success(`Folder / Document Linked successfully!`);
        },
        (err) => {
          setLoading(false);
          KoToast.error(`error`);
        }
      );
    } else {
      FilesAPI.linkToWorkspace(currentFile?.documentId, targetWorkspace).then(
        (data) => {
          getFolders(paginationFolder, currentFolder, 'false');
          setLoading(false);
          setLinkToWorkspaceModal(false);
          KoToast.success(`Folder / Document Linked successfully!`);
        },
        (err) => {
          setLoading(false);
          KoToast.error(`error`);
        }
      );
    }

  };

  const onExtraClick = (record, col) => {
    let fids = {
      id: record.documentId || record?.folderId,
      isStarred: !record.isStarred,
      name: col ? col : 'file'
    };
    setLoading(true);
    FilesAPI.starredDocument(fids).then(
      (data) => {
        setLoading(false);
        getFolders(paginationFolder);
        getDocuments(pagination);
        KoToast.success(`Document starred successfully!`);
      },
      (err) => {
        setLoading(false);
        KoToast.error(`error`);
      }
    );
  };

  const handelFileActions = (row, key) => {
    setCurrentFile(row);
    if (key === 'rename') {
      setRenameFileModal(true);
    } else if (key === 'linkToWorkspace') {
      setLinkToWorkspaceModal(true);
    }
    else if (key === 'share') {
      setFileShareModal(true);
    } else if (key === 'download') {
      if (row.type === 'docx') {
        exportSlateToDocx(row?.url, row?.name + '.docx', setLoading);
      } else {
        downloadFile(row?.url, row?.name, setLoading);
      }
    } else if (key === 'delete') {
      onDelete(row);
    } else if (key === 'star') {
      onExtraClick(row, 'file');
    } else if (key === 'move') {
      setMoveFileModal(true);
    }

  };


  const onSearchText = (text) => {
    let q = pagination;
    q['search'] = text;
    getDocuments(q);
  };

  const onSearchTextFolder = (text) => {
    if (text) {
      let q = paginationFolder;
      q['search'] = text;
      getFolders(q);
      onSearchText(text);
    } else {
      const p = {
        size: 10000,
        offset: 0,
        page: 1
      };
      getFolders(p);
      getDocuments(p);
    }

  };

  const handleFinishRenameFile = (values) => {
    setLoading(true);

    FilesAPI.renameDocument(values, currentFile.documentId).then(
      (data) => {
        let q = pagination;
        // q['folderId'] = act' iveFolder?.folderId;
        getDocuments(q, values, currentFolder?.folderId);
        setLoading(false);
        setRenameFileModal(false);
        KoToast.success(`Document renamed successfully!`);
      },
      (err) => {
        setLoading(false);
        KoToast.error(`error`);
      }
    );
  };

  const getByFolderId = (folder, values) => {
    setLoading(true);
    FilesAPI.getFolderById(folder?.folderId, paginationFolder).then(
      (data) => {
        const currentFolderData = data.folder;
        setFolders(currentFolderData?.children || []);
        setTotalFolderCount(data.totalCount);
        getDocuments(pagination, null, folder?.folderId);
        setCurrentFolder(folder);
        setLoading(false);
        if (values) {
          setHighlightedFolder(values);
        }

        setBreadcrumbPath((prevPath = []) => {
          const existingIndex = prevPath.findIndex(
            (item) => item.folderId === currentFolderData.folderId
          );
          if (existingIndex !== -1) {
            return prevPath.slice(0, existingIndex + 1);
          }
          return [
            ...prevPath,
            {
              folderId: currentFolderData.folderId,
              name: currentFolderData.name || currentFolderData.title
            }
          ];
        });

      },
      (err) => {
        console.error(err);
        setLoading(false);
      }
    );
  };

  // const items = [
  //   {
  //     label: 'Create Folder',
  //     key: '1',
  //     icon: <KoIcon name="FolderLine" />,
  //     onClick: () => { currentFolder?.folderId ? setFolderSubModal(true): setFolderModal(true); }
  //   },
  //   {
  //     label: 'Create File',
  //     key: '2',
  //     icon: <KoIcon name="FileOutlined" />,
  //     onClick: () => { setCurrentFile(); setFileType('docx'); setOpenFileCreate(true); }
  //   },
  //   {
  //     label: 'Upload File',
  //     key: '3',
  //     icon: <KoIcon name="UploadOutlined" />,
  //     onClick: () => { setCurrentFile(); setUploadFileModal(true); }
  //   }
  // ];

  return (
    <div className={styles.container} onClick={() => dropdownVisible && setDropdownVisible(false)}>
      {isLoading && <KoLoader />}
      {/* <KoDropdown menu={{ items }} trigger={['contextMenu']} > */}
      <div className={styles.wrapper}>
        <KoAffix top={50}>
          <div className={styles.headerWrapper}>
            <div className={styles.breadWrapper}>
              <KoTitle onClick={() => getinistallData()} className={`${styles.dark}`} level={4} text={`My Drive`} />
              {breadcrumbPath?.length > 0 && <KoIcon name="ArrowRightOutlined" />}
              <KoBreadcrumb
                className={styles.breadWrapper}
                separator={<KoIcon name="ArrowRightOutlined" />}
                items={breadcrumbPath?.map(folder => ({
                  title: (
                    <KoText
                      className={`${!folder?.name ? styles.dark : styles.lite}`}
                      text={folder?.name}
                    />
                  ),
                  onClick: () => getByFolderId(folder)
                }))}
              />
            </div>
            <div className={styles.searchWrapper}>
              <KoSearch allowClear={true} className={styles.search} placeholder="Type to search folders / files" onChange={(e) => onSearchTextFolder(e.target.value)} />
              <div className={styles.documents}>
                <KoButton onClick={() => { setFileShareModal(true); }} disabled={selectedDocx?.length > 0 ? false : true} label='Share' type='primary' icon={<KoIcon name={'AddtoGroupsOutlined'} width={18} height={18} />} />
                <KoButton onClick={() => { setMoveFileModal(true); }} disabled={selectedDocx?.length > 0 ? false : true} label='Move' type='primary' icon={<KoIcon name={'MoveToOutlined'} width={18} height={18} />} />
                <KoButton onClick={() => { setDeleteFileModal(true); }} disabled={selectedDocx?.length > 0 ? false : true} label='Delete' type='primary' danger icon={<KoIcon name={'DeleteOutlined'} width={18} height={18} />} />
              </div>
              <KoDropdown
                overlayClassName={styles.settings}
                popupRender={(menu) => (
                  <div className={styles.customDropdown} >
                    <div className={styles.customDropdownContnet}>
                      <ul>
                        <li
                          onClick={() => {
                            if (breadcrumbPath?.length > 0 && currentFolder) {
                              setCurrentFolder(currentFolder);
                              setFolderSubModal(true);
                            } else {
                              setCurrentFolder();
                              setFolderModal(true);
                            }
                            document.body.click();
                          }}
                        >
                          <KoIcon name="FolderLine" />
                          <KoText text="Create Folder" />
                        </li>

                        <li
                          onClick={() => window.open(`/open/document/${currentFolder?.folderId ? currentFolder?.folderId :'root'}/new`, '_blank')}>
                          <KoIcon name="FileOutlined" />
                          <KoText text="Create File" />
                        </li>
                        <li
                          onClick={() => window.open(`/open/document/${currentFolder?.folderId ? currentFolder?.folderId :'root'}/whiteboard`, '_blank')}>
                          <KoIcon name="FileOutlined" />
                          <KoText text="Create Whiteboard" />
                        </li>
                        <li
                          onClick={() => {
                            if (breadcrumbPath?.length > 0 && currentFolder) {
                              setCurrentFolder(currentFolder);
                            } else {
                              setCurrentFile();
                            }
                            setUploadFileModal(true);
                            document.body.click();
                          }}
                        >
                          <KoIcon name="UploadOutlined" />
                          <KoText text="Upload File" />
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                placement={'bottomRight'}>
                <KoButton type='primary' icon={<KoIcon name="PlusOutlined" width={18} height={18} color="#FFF" />} label='New' />
              </KoDropdown>
            </div>
          </div>
        </KoAffix>
        {folders?.length > 0 && <div className={styles.folderTitile}>
          <KoTitle className={`${styles.dark}`} level={4} text={`Folders`} />
        </div>}
        <div className={styles.ulCreate}>
          {folders?.map((folder, i) => {
            const permission = getDrivePermission(folder?.sharedWith, getCookie('userId'), folder?.createdBy);
            return (<div onMouseDown={() => { setHighlightedFolder(); }} key={i} className={`${styles.li} ${(currentFolder?.folderId === folder?.folderId || highlightedFolder?.folderId === folder?.folderId) ? styles.activeFolder : ''}`}>
              <div className={styles.headerCreate}>
                <KoButton className={`${styles.btnmedium}`} color="default" variant="filled" icon={<KoIcon color="#FFF" width={23} height={23} name="FolderLine" />} />
                <div onClick={() => { getByFolderId(folder); }}>
                  <KoText className={styles.title} text={folder?.name} />
                  <div className={styles.folderChild}>
                    <KoText className={styles.fileCount} ellipsis={true} text={`${folder?.fileCount || 0} ${(folder?.fileCount === 1 || folder?.fileCount === 0) ? 'File' : 'Files'}`} />
                  </div>
                </div>
              </div>
              <KoDropdown
                trigger={['click']}
                open={dropdownVisible && currentFolder?.folderId === folder?.folderId}
                overlayClassName={styles.settings}
                popupRender={(menu) => (
                  <div className={styles.customDropdown} >
                    <div className={styles.customDropdownContnet}>
                      <ul>
                        {permission.canEdit && (
                          <>
                            <li onClick={() => { setDropdownVisible(false); setFolderSubModal(true); }}>
                              <KoIcon name={'FolderLine'} />
                              <KoText text={'Create Folder'} />
                            </li>
                            <li onClick={() => { setDropdownVisible(false); navigate(`/dms/file/${folder?.folderId}/new`); }}>
                              <KoIcon name={'FileOutlined'} />
                              <KoText text={'Create File'} />
                            </li>
                            <li onClick={() => { setDropdownVisible(false); setUploadFileModal(true); }}>
                              <KoIcon name={'UploadOutlined'} />
                              <KoText text={'Upload File'} />
                            </li>
                            <li onClick={() => { setDropdownVisible(false); setFolderModal(folder); }}>
                              <KoIcon name={'EditOutlined'} />
                              <KoText text={'Rename'} />
                            </li>
                            <li onClick={() => { setDropdownVisible(false); setCurrentFolder(folder); setLinkToWorkspaceModal(true); }}>
                              <KoIcon name={'WorkspaceOutlined'} color={'#FF0000'} />
                              <KoText text={'Link to Workspace'} />
                            </li>
                            <li onClick={() => { setDropdownVisible(false); setCurrentFolder(folder); setFolderShareModal(true); }}>
                              <KoIcon name={'AddtoGroupsOutlined'} color={'#FF0000'} />
                              <KoText text={'Share'} />
                            </li>
                            <li onClick={() => { setDropdownVisible(false); setCurrentFolder(folder); setDeleteModal(true); }}>
                              <KoIcon name={'DeleteOutlined'} color={'#FF0000'} />
                              <KoText text={'Delete'} />
                            </li>
                          </>
                        )}
                        <li onClick={() => { setDropdownVisible(false); onExtraClick && onExtraClick(folder, 'folder'); }}>
                          <KoIcon name={'StarOutlined'} color={folder?.isStarred ? 'var(--query)' : ''} />
                          <KoText text={folder?.isStarred ? 'Unstar' : 'Star'} />
                        </li>

                        {permission.canEdit && (
                          <li onClick={() => { setDropdownVisible(false); setCurrentFolder(folder); setDeleteModal(true); }}>
                            <KoIcon name={'DeleteOutlined'} color={'#FF0000'} />
                            <KoText text={'Delete'} />
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                )}
                placement={'bottomRight'}>
                <KoButton onClick={() => { setCurrentFolder(folder); setDropdownVisible(true); }} type='text' icon={<KoIcon name="VerticalMenuOutlined" width={18} height={18} />} className={`${styles.btn} smallBtn`} />
              </KoDropdown>
            </div>);
          })}
        </div>
        {
          (folders?.length === 0 && recentRequestList?.length === 0) && <div className={styles.empty}>
            <KoEmpty title="No folders or documents found" subTyext='There are currently no folders or documents available.' />
          </div>
        }

        {recentRequestList?.length > 0 && <div className={styles.folderTitile}>
          <KoTitle className={`${styles.dark}`} level={4} text={'Files'} />
        </div>}
        <div className={styles.fileWrapper}>
          {recentRequestList?.length > 0 && recentRequestList?.map((docx, index) => (
            <FileInfo highlighted={highlightedFile?.name === docx?.name} key={index} data={docx?.name} row={docx}
              onCellClick={onCellClick}
              onDocxSelection={onDocxSelection}
              selectedDocx={selectedDocx}
              getDocuments={()=>getDocuments(pagination, null, currentFolder?.folderId)}
              handelFileActions={handelFileActions}
              options={['rename', 'share', 'delete', 'move', 'star', 'download', 'linkToWorkspace']}
              onExtraClick={onExtraClick} colName={'folder'} />
          ))}
        </div>

        {/* {openFileCreate && <DocumentCreate
          showComments={true}
          openFileCreate={openFileCreate}
          setOpenFileCreate={setOpenFileCreate}
          renameDocument={() => setRenameFileModal(true)}
          renamedTitle={rform.getFieldValue('name')}
          folderId={currentFolder?.folderId}
          getDocuments={(values) => { getDocuments(pagination, values, currentFolder?.folderId); currentFolder?.folderId ? getByFolderId(currentFolder) : getFolders(pagination); }}
          type={fileType}
          documentId={currentFile?.documentId} />} */}

        <KoModal
          title={currentFolder?.folderId ? `Update Folder ${currentFolder?.name?.toUpperCase()}` : 'Create Folder'}
          centered
          open={isFolderOpen}
          afterClose={() => { form.resetFields(); setCurrentFile(); }}
          handleOk={() => { form.resetFields(); setCurrentFile(); setFolderModal(false); }}
          onClose={() => { form.resetFields(); setCurrentFile(); setFolderModal(false); }}
          width={680}
          footer={[
            <KoButton key='cancel' label='Cancel' onClick={() => { setFolderModal(!isFolderOpen); form.resetFields(); }} />,
            <KoButton key='create' loading={isLoading} type='primary' label={`${currentFolder?.folderId ? 'Update' : 'Create'}`} onClick={() => form.submit()} />
          ]}
        >
          {isLoading && <KoLoader circle={false} />}
          <KoFolderCrud form={form} handleFinish={handleFolderFinish} initialValues={currentFolder} />
        </KoModal>

        <KoModal
          title={'Create Folder'}
          centered
          open={folderSubModal}
          afterClose={() => { form.resetFields(); }}
          handleOk={() => { form.resetFields(); setFolderSubModal(false); }}
          onClose={() => { form.resetFields(); setFolderSubModal(false); }}
          width={680}
          footer={[
            <KoButton key='cancel' label='Cancel' onClick={() => { setFolderSubModal(false); subform.resetFields(); }} />,
            <KoButton key='create' loading={isLoading} type='primary' label={`Create`} onClick={() => subform.submit()} />
          ]}
        >
          {isLoading && <KoLoader circle={false} />}
          <KoFolderCrud form={subform} currentFolder={currentFolder} handleFinish={handleFolderSubFinish} initialValues={{}} />
        </KoModal>




        <KoModal
          title={`Delete folder ${currentFolder?.name?.toUpperCase()}`}
          centered
          open={isOpenDelete}
          afterClose={() => { setCurrentFile(); }}
          handleOk={() => { setCurrentFile(); setDeleteModal(false); }}
          onClose={() => { setCurrentFile(); setDeleteModal(false); }}
          width={580}
          footer={[
            <KoButton key='cancel' label='Cancel' onClick={() => setDeleteModal(!isOpenDelete)} />,
            <KoButton key='reset' loading={isLoading} color="danger" variant="solid" type='primary' label='Delete' onClick={() => handleFinishDelete()} />
          ]}
        >
          {isLoading && <KoLoader circle={false} />}
          <div className={styles.delWrapper}>
            <KoTitle level={5} text={`Are you sure you want to delete this folder?`} />
            <KoText text={`This action is irreversible, and it will result in the removal of their associated data and Kwapio license.`} />
          </div>
        </KoModal>

        <KoModal
          title={`Delete document ${currentFile?.name ? currentFile?.name?.toUpperCase() : ''}`}
          centered
          open={isdeleteFile}
          afterClose={() => { setCurrentFile(); }}
          handleOk={() => { setCurrentFile(); setDeleteFileModal(false); }}
          onClose={() => { setCurrentFile(); setDeleteFileModal(false); }}
          width={580}
          footer={[
            <KoButton key='cancel' label='Cancel' onClick={() => setDeleteFileModal(false)} />,
            <KoButton key='reset' loading={isLoading} color="danger" variant="solid" type='primary' label='Delete' onClick={() => handleFinishDeleteFile()} />
          ]}
        >
          {isLoading && <KoLoader circle={false} />}
          <div className={styles.delWrapper}>
            <KoTitle level={5} text={`Are you sure you want to delete this document?`} />
            <KoText text={`This action is irreversible, and it will result in the removal of their associated data.`} />
          </div>
        </KoModal>

        {isFolderShareOpen && <FileSharePanel
          title={`${currentFolder?.name}`}
          onClose={() => setFolderShareModal(false)}
          initialShared={selectedDocx?.length > 0 ? initialShared : currentFolder?.sharedWith}
          onSave={(sharedWith) => {
            handleFolderShareFinish({ sharedWith: sharedWith });
          }}
        />}

        {isFileShareOpen && <FileSharePanel
          title={`${currentFile?.name}`}
          onClose={() => setFileShareModal(false)}
          initialShared={selectedDocx?.length > 0 ? initialShared : currentFile?.sharedWith}
          onSave={(sharedWith) => {
            handleFileShareFinish({ sharedWith: sharedWith });
          }}
        />}



        <KoModal
          title={'Upload File'}
          centered
          open={uploadFileModal}
          afterClose={() => { setCurrentFile(); }}
          handleOk={() => { setUploadFileModal(false); }}
          onClose={() => { setUploadFileModal(false); }}
          width={760}
          footer={[]}
        >
          <div className={`${styles.uploadWrapper} customUpload`}>
            {isLoading && <KoLoader circle={false} />}
            <KoUpload
              isDnd={true}
              listType="picture"
              {...props}
            >
              <div className={styles.upload}>
                <p className="ant-upload-text">{`Click or drag file to this area to upload  ${currentFolder?.name ? 'you are uploading to ' + currentFolder?.name + ' folder' : ''}`} </p>
                <p className="ant-upload-hint">
                  Support for single or bulk uploads. Uploading banned files is strictly prohibited.
                </p>
              </div>
            </KoUpload>
          </div>
        </KoModal>

        <KoModal
          title={'Move to Folder'}
          centered
          open={moveFileModal}
          handleOk={() => { setMoveFileModal(false); }}
          afterClose={() => { setCurrentFile(); }}
          onClose={() => { setMoveFileModal(false); }}
          width={550}
          footer={[
            <KoButton key='cancel' label='Cancel' onClick={() => setMoveFileModal(false)} />,
            <KoButton key='create' loading={isLoading} type='primary' label={'Move'} onClick={() => moveToFolder(pagination, currentFolder)} />
          ]}
        >
          <div className={`${styles.uploadWrapper}`}>
            {isLoading && <KoLoader circle={false} />}
            <KoText text={`Select a folder to move the file(s) to. (${selectedDocx?.length} selected)`} />
            <label>&nbsp;</label>
            <KoSelect
              placeholder="Select module"
              showSearch
              optionFilterProp="label"
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
              onChange={v => onSelectTargetFolder(v)}
              options={folders && getFlattenedFoldersWithPaths(folders)}
            />
          </div>
        </KoModal>

        <KoModal
          title={'Link a File or Folder to Workspace'}
          centered
          open={linkToWorkspaceModal}
          handleOk={() => { setLinkToWorkspaceModal(false); }}
          afterClose={() => { setCurrentFile(); }}
          onClose={() => { setLinkToWorkspaceModal(false); }}
          width={550}
          footer={[
            <KoButton key='cancel' label='Cancel' onClick={() => setLinkToWorkspaceModal(false)} />,
            <KoButton key='create' loading={isLoading} type='primary' label={'Move'} onClick={() => LinkToWorkspace()} />
          ]}
        >
          <div className={`${styles.uploadWrapper}`}>
            {isLoading && <KoLoader circle={false} />}
            <KoText text={`Linking the selected folder or document to a workspace will make it accessible to all team members within that workspace.`} />
            <label>&nbsp;</label>
            <KoSelect
              placeholder="Select workspace"
              showSearch
              mode="multiple"
              optionFilterProp="label"
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
              onChange={(v) => onSelectTargetWorkspace(v)}
              options={workspaces?.map((workspace) => ({
                label: workspace?.name,
                value: workspace?.workspaceId
              }))}
            />
          </div>
        </KoModal>

        <KoModal
          title={'Rename File'}
          centered
          open={renameFileModal}
          afterClose={() => { rform.resetFields(); setCurrentFile(); }}
          handleOk={() => { setRenameFileModal(false); }}
          onClose={() => { setRenameFileModal(false); }}
          width={550}
          footer={[
            <KoButton key='cancel' label='Cancel' onClick={() => setRenameFileModal(false)} />,
            <KoButton key='create' loading={isLoading} type='primary' label={'Rename'} onClick={() => rform.submit()} />
          ]}
        >
          <div className={`${styles.uploadWrapper}`}>
            {isLoading && <KoLoader circle={false} />}
            <FileRenameCrud form={rform} initialValues={currentFile} handleFinish={handleFinishRenameFile} />
          </div>
        </KoModal>
      </div>
      {/* </KoDropdown> */}
    </div>
  );
}

export default FileDrive;